module.exports = __webpack_public_path__ + "img/dep_stationeryandprint@2x.d48f15bd.png";